
<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" :rules="rules" ref="form" label-width="130px"
        v-loading="loading">

        <el-row>
          <el-col :span="24">
            <el-form-item prop="sitePhoto" label="现场图片">
              <div class="row-wrap">

                <div class="images-wrap" v-if="formData.sitePhoto"  >
                  <i class="el-icon-error close-icon" @click="delImage('sitePhoto')"></i>
                  <el-image style="width: 100%; height: 100%" :src="formData.sitePhoto"
                    :preview-src-list="[formData.sitePhoto]" fit="cover" />
                </div>

                <el-upload class="upload-demo" v-else :show-file-list="false" :action="$apis.common.uploadUrl"
                  :on-success="handleSuccess1" :before-upload="beforeUpload" list-type="picture-card">
                  <i class="el-icon-plus"></i>
                  <div slot="tip" class="el-upload__tip">
                    图片大小不能超过10MB~
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>

export default {
  name: 'firefightingClockInAdd',

  data () {
    return {
      formData: {

        sitePhoto: ''

      },

      rules: {

        sitePhoto: [
          {
            required: true,
            message: '请上传现场图片',
            trigger: ['blur', 'change']
          }
        ]

      },
      loading: false

    }
  },
  created () {
    if (this.clockId) {
      this.loadData()
    }
  },
  computed: {
    clockId () {
      return this.$route.query.clockId
    }

  },
  methods: {

    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.firefightingClockIn.selectPaFireClockinByClockId, {
          params: { clockId: this.clockId }
        })
        .then(res => {
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    },

    handleSuccess1 (res) {
      this.formData.sitePhoto = res.data.filePrefix + res.data.fileUrl
    },

    delImage (filed) {
      this.formData[filed] = ''
    },
    beforeUpload (file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件')
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB')
      }
      return isImage && isLt10M
    },

    submit () {
      this.$refs.form
        .validate()
        .then(() => {
          this.loading = true

          const url = this.$apis.firefightingClockIn.insertPaFireClockin

          this.$axios.post(url, { ...this.formData }).then(() => {
            this.$router.back()
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}

.images-wrap {
  width: 148px;
  height: 148px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;
  margin-right: 14px;

  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    z-index: 10;
    font-size: 18px;
    color: red;
    cursor: pointer;
  }
}
</style>
